import React from 'react';
import { IconProps } from '../../icons/types';

const InfoIcon: React.FC<IconProps> = props => {
  const { className = '', size = 16, fillColor = 'var(--grayscale-3)' } = props;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_14_55489" maskUnits="userSpaceOnUse" x="0" y="0" width={size} height={size}>
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14_55489)">
        <path
          d="M7.33447 11.3328H8.66781V7.33276H7.33447V11.3328ZM8.00114 5.99943C8.19003 5.99943 8.34847 5.93543 8.47647 5.80743C8.60403 5.67987 8.66781 5.52165 8.66781 5.33276C8.66781 5.14387 8.60403 4.98543 8.47647 4.85743C8.34847 4.72987 8.19003 4.6661 8.00114 4.6661C7.81225 4.6661 7.65403 4.72987 7.52647 4.85743C7.39847 4.98543 7.33447 5.14387 7.33447 5.33276C7.33447 5.52165 7.39847 5.67987 7.52647 5.80743C7.65403 5.93543 7.81225 5.99943 8.00114 5.99943ZM8.00114 14.6661C7.07892 14.6661 6.21225 14.491 5.40114 14.1408C4.59003 13.791 3.88447 13.3161 3.28447 12.7161C2.68447 12.1161 2.20958 11.4105 1.85981 10.5994C1.50958 9.78832 1.33447 8.92165 1.33447 7.99943C1.33447 7.07721 1.50958 6.21054 1.85981 5.39943C2.20958 4.58832 2.68447 3.88276 3.28447 3.28276C3.88447 2.68276 4.59003 2.20765 5.40114 1.85743C6.21225 1.50765 7.07892 1.33276 8.00114 1.33276C8.92336 1.33276 9.79003 1.50765 10.6011 1.85743C11.4122 2.20765 12.1178 2.68276 12.7178 3.28276C13.3178 3.88276 13.7927 4.58832 14.1425 5.39943C14.4927 6.21054 14.6678 7.07721 14.6678 7.99943C14.6678 8.92165 14.4927 9.78832 14.1425 10.5994C13.7927 11.4105 13.3178 12.1161 12.7178 12.7161C12.1178 13.3161 11.4122 13.791 10.6011 14.1408C9.79003 14.491 8.92336 14.6661 8.00114 14.6661Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default InfoIcon;
